module.exports = __webpack_public_path__ + "static/media/question-1.fd0982b7.svg";